import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HowItWorksSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-24 px-6" style={{
    background: '#111827'
  }} data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-133">
          <div className="amber-divider mb-8" data-id="element-134" />
          <p className="text-center text-sm uppercase tracking-widest mb-4" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#D4A853'
        }} data-id="element-135">
            Simple et rapide
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-136">
            Comment ça marche
          </h2>

          <div className="space-y-6" data-id="element-137">
            {/* Step 1 */}
            <div className="flex gap-6 items-start" data-id="element-138">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              color: '#0D1B2A',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-139">
                1
              </div>
              <div className="pt-2" data-id="element-140">
                <h3 className="text-lg font-semibold mb-2" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-141">
                  Identifiez le Pic
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-142">
                  Reconnaissez les signes physiques de l'alerte dès qu'ils
                  arrivent — la tension dans la poitrine, les pensées qui
                  s'accélèrent, la chaleur dans le visage.
                </p>
              </div>
            </div>

            {/* Connector */}
            <div className="ml-7 w-px h-6" style={{
            background: 'rgba(212,168,83,0.3)'
          }} data-id="element-143" />

            {/* Step 2 */}
            <div className="flex gap-6 items-start" data-id="element-144">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              color: '#0D1B2A',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-145">
                2
              </div>
              <div className="pt-2" data-id="element-146">
                <h3 className="text-lg font-semibold mb-2" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-147">
                  Appliquez le Reset
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-148">
                  Suivez les 3 étapes physiques (respiration + points de
                  switch). Votre corps reçoit le signal qu'il est en sécurité.
                </p>
              </div>
            </div>

            {/* Connector */}
            <div className="ml-7 w-px h-6" style={{
            background: 'rgba(212,168,83,0.3)'
          }} data-id="element-149" />

            {/* Step 3 */}
            <div className="flex gap-6 items-start" data-id="element-150">
              <div className="flex-shrink-0 w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold" style={{
              background: 'linear-gradient(135deg, #D4A853, #E8C47A)',
              color: '#0D1B2A',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-151">
                3
              </div>
              <div className="pt-2" data-id="element-152">
                <h3 className="text-lg font-semibold mb-2" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#F5F0E8'
              }} data-id="element-153">
                  Libérez le Mental
                </h3>
                <p className="text-sm leading-relaxed" style={{
                fontFamily: 'DM Sans, sans-serif',
                color: '#8A8070'
              }} data-id="element-154">
                  Utilisez la décharge stratégique pour vider la boucle de
                  rumination. Posez vos peurs sur papier et laissez votre
                  cerveau se déconnecter.
                </p>
              </div>
            </div>
          </div>

          {/* Time badge */}
          <div className="mt-10 rounded-xl p-4 text-center" style={{
          background: 'rgba(212,168,83,0.08)',
          border: '1px solid rgba(212,168,83,0.2)'
        }} data-id="element-155">
            <p className="text-sm" style={{
            fontFamily: 'DM Sans, sans-serif',
            color: '#C8C0B0'
          }} data-id="element-156">
              ⏱ Durée totale :{' '}
              <strong style={{
              color: '#D4A853'
            }} data-id="element-157">
                moins de 10 minutes
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}